import { Box } from '@mui/material';
import { MobilePadding, ContainerMaxWidth } from './organisms/layouts/Layout';
import { Integrations } from './NewWebsite/Integrations';
import { DesktopPadding } from 'pages';
export const PartnersAndIntegrations = () => {
  return <Box sx={{
    py: '4rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    p: {
      xs: MobilePadding,
      md: DesktopPadding
    },
    maxWidth: ContainerMaxWidth,
    mx: 'auto'
  }}>
      <Integrations />
    </Box>;
};